import { useEffect } from 'react';
import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LwFormInput, LwFormSelect } from 'redesign';
import { GetPartnerResponse } from 'hq/services/partner-service.types';
import { PartnerInformationFormData } from './partner-information.types';

type Props = {
  partner: GetPartnerResponse;
};

export const PartnerInformationEditForm = ({ partner }: Props) => {
  const { control, setValue } = useFormContext<PartnerInformationFormData>();
  const { t } = useTranslation('hq-screen-specific');

  useEffect(() => {
    setValue('name', partner.name);
    setValue('deactivated', partner.deactivated === true ? 'true' : 'false');
  }, [partner.name, partner.deactivated, setValue]);

  const statusOptions = [
    { value: 'true', label: t('partners.info_edit.status.deactivated') },
    { value: 'false', label: t('partners.info_edit.status.active') },
  ];

  return (
    <form>
      <Grid item spacing={2} xs={6}>
        <Grid item xs={12}>
          <LwFormInput
            name="name"
            label={t('partners.form.name_label')}
            control={control}
            rules={{ required: t('partners.form.name_required') }}
          />
          <LwFormSelect
            name="deactivated"
            label={t('partners.info_edit.status_label')}
            control={control}
            options={statusOptions}
          />
        </Grid>
      </Grid>
    </form>
  );
};
